function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import Popover from '../Popover';
export var Flyout = function Flyout(props) {
  return React.createElement(Popover, _extends({}, props, {
    interactive: true,
    arrow: true
  }));
};
Flyout.defaultProps = {
  maxWidth: 380,
  trigger: 'click'
};
export default styled(Flyout).withConfig({
  displayName: "Flyout",
  componentId: "sc-9rkpvq-0"
})(["padding:16px;text-align:left;"]);